import { NodeType, Node as ProsemirrorNode, ResolvedPos } from 'prosemirror-model';
import { Selection } from 'prosemirror-state';

// FROM: https://github.com/atlassian/prosemirror-utils/blob/master/src/selection.js

// Checks if there's a parent node of a given `nodeType`.
export function hasParentNodeOfType(nodeType) {
  return function(selection) {
    return hasParentNode((node) => equalNodeType(nodeType, node))(selection);
  };
}

export function findParentNodeOfType(nodeType) {
  return function(selection) {
    return findParentNode((node) => equalNodeType(nodeType, node))(selection);
  };
}

// Checks if the type a given `node` equals to a given `nodeType`.
export function equalNodeType(nodeType, node) {
  return (Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1) || node.type === nodeType;
}

// Checks if there's a parent node `predicate` returns truthy for.
export function hasParentNode(predicate) {
  return function(selection) {
    return !!findParentNode(predicate)(selection);
  };
}

// Iterates over parent nodes, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
export function findParentNode(predicate) {
  return function({ $from }) {
    return findParentNodeClosestToPos($from, predicate);
  };
}

// Iterates over parent nodes starting from the given `$pos`, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
export function findParentNodeClosestToPos(
  $pos,
  predicate
) {
  for (let i = $pos.depth; i > 0; i--) {
    const node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node
      };
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/findNodes.js